import { useHistory } from 'react-router';
export const ServiceOrderButton = ({ title = '', onClick }) => {
    return (
        <div
            className="mainteance-service-btn nice-flex nice-flex-center"
            style={{ backgroundImage: `url('/assets/images/maintenance.png')` }}
            onClick={() => {
                if (onClick) {
                    onClick(true);
                }
            }}
        >
            <div className="text-24 text-white text-bold">
                {title}
            </div>
        </div>
    );
};
const SERVICE_ICONS = {
    BODY_PAINT: "/assets/icons/services/painting.svg",
    MECHANIC: "/assets/icons/services/mechanics.svg",
    GENERAL: "/assets/icons/services/general.svg",
    PERIODIC: "/assets/icons/services/maintenance-periodic.svg",
    DIAGNOSE: "/assets/icons/services/diagonise.svg",
    PROTECTION: "/assets/icons/services/protection.svg",
    TINTING: "/assets/icons/services/tinting.svg",
    ENGINE: "/assets/icons/services/engine.svg"
};

const getServiceIcon = (title) => {
    if (!title) return SERVICE_ICONS.GENERAL;
    const lowerTitle = title.toLowerCase();

    if (lowerTitle.includes('body') || lowerTitle.includes('paint')) return SERVICE_ICONS.BODY_PAINT;
    if (lowerTitle.includes('periodic') || lowerTitle.includes('دورية')) return SERVICE_ICONS.PERIODIC;
    if (lowerTitle.includes('mechanic') || lowerTitle.includes('ميكانيكا')) return SERVICE_ICONS.MECHANIC;
    if (lowerTitle.includes('diagnos') || lowerTitle.includes('فحص')) return SERVICE_ICONS.DIAGNOSE;
    if (lowerTitle.includes('protect') || lowerTitle.includes('حماية')) return SERVICE_ICONS.PROTECTION;
    if (lowerTitle.includes('tint') || lowerTitle.includes('تظليل')) return SERVICE_ICONS.TINTING;
    if (lowerTitle.includes('engine') || lowerTitle.includes('محرك')) return SERVICE_ICONS.ENGINE;

    return SERVICE_ICONS.GENERAL;
};

export const MaintenanceServiceBox = ({ serviceID = '', title = '', to = '', minPrice = 0, maxPrice = 0, image, onServiceOrder }) => {
    const history = useHistory();

    const handleClick = (event) => {
        if (to === "#") {
            event.stopPropagation();
            if (onServiceOrder) {
                onServiceOrder(serviceID);
            }
        } else {
            history.push(to);
        }
    };

    const iconSrc = getServiceIcon(title);

    return (
        <div className="mainteance-box" onClick={handleClick}>
            <div className="icon-wrapper">
                <div className="icon-inner">
                    <div
                        className="service-icon"
                        style={{
                            WebkitMaskImage: `url(${iconSrc})`,
                            maskImage: `url(${iconSrc})`
                        }}
                        title={title}
                    />
                </div>
            </div>
            <div className="mainteance-box-details">
                <h1 className="text-bold">{title}</h1>
            </div>
        </div>
    );
};
